import React, { useEffect, useState } from "react";
import TextEditor from "../../../Main/TextEditor";
import middleware from "../../../Api/Middleware";
import { ButtonBlue } from "../../../HouseStyle/Components/Buttons";
import ToastPromise from "../../../Toasts/ToastPromise";
import LoadingIcon from "../../../HouseStyle/Components/LoadingIcon";

const EmailSettings = () => {
  const [backoffice, setBackoffice] = useState([]);
  const [colors, setColors] = useState({});
  const [loading, setLoading] = useState(true);
  const [emailFootnoteCopy, setEmailFootnoteCopy] = useState();
  const colorNameMapping = {
    email_color_1: "Mailachtergrondkleur",
    email_color_2: "Link tekst, knop achtergrond, footer regel kleur",
    email_color_3: "Header achtergrondkleur",
    email_color_4: "Tekstenkleur",
    email_color_5: "Tekstachtergrondkleur",
  };
  const companyInfo = {
    bedrijfsnaam: "company_name",
    omschrijving: "description",
    postcode: "postal_code",
    huisnummer: "house_number",
    toevoeging: "addition",
    betaaltermijn: "payment_term",
    straat: "street_name",
    stad: "city",
    provincie: "province",
    land: "country",
    telefoonnummer: "phone_number",
    email: "email",
    "factuur huisnummer": "invoice_house_number",
    "factuur straat": "invoice_streetname",
    "factuur toevoeging": "invoice_addition",
    "factuur stad": "invoice_city",
    factuuremail: "invoicemail",
    website: "website",
    iban: "iban",
    "start werkdag": "begin_workday",
    "eind werkdag": "end_workday",
    adres: "address",
    factuuradres: "invoice_address",
  };

  /**
   * Get all data out of the database and map the tags in the email_footer to the keys
   * Turn the email site and phone into a tag with the right href
   */
  async function fetchAll() {
    const res = await middleware.get("settings/backoffice");
    const data = res.data.data[0];

    const backofficeData = {
      ...data,
      address: `${data.street_name} ${data.house_number} ${data.addition}`,
      invoice_address: `${data.invoice_streetname} ${data.invoice_house_number} ${data.invoice_addition}`,
      website: `<a href="${data.website}">${data.website}</a>`,
      email: `<a href="mailto:${data.email}">${data.email}</a>`,
      invoicemail: `<a href="mailto:${data.invoicemail}">${data.invoicemail}</a>`,
      phone_number: `<a href="tel:${data.phone_number}">${data.phone_number}</a>`,
      email_footnote: revertTags(data.email_footnote, true),
    };
    setBackoffice(backofficeData);
    replaceData(revertTags(data.email_footnote, true), backofficeData);
    setColors(
      Object.entries(data).reduce((acc, [key, value]) => {
        if (key.includes("email_color")) {
          acc[key] = value;
        }
        return acc;
      }, {}),
    );
    setLoading(false);
  }

  useEffect(() => {
    fetchAll();
  }, []);

  /**
   * This is to save the changes
   */
  async function submitEmailData() {
    ToastPromise({
      promise: middleware.put("settings/backoffice", {
        email_footnote: revertTags(backoffice.email_footnote),
        setting_id: 1,
        ...colors,
      }),
      pending: "aan het uploaden",
      successRenderer: () => {
        return "De data is succesvol geupload";
      },
      errorRenderer: (er) => {
        return "Iets is misgegaan";
      },
    });
  }

  /**
   * Swap the tags with the belonging key or value
   * @param {String} val the string containing the key or value as tags
   * @param {Boolean} valueKey if the value is the key and the value is the key
   * @returns the string witht the swapped key value
   */
  function revertTags(val, valueKey = false) {
    let rval = val;
    if(rval)
    Object.entries(companyInfo).forEach(([key, value]) => {
      if (valueKey) rval = rval.replace(new RegExp(`{${value}}`,"ig"), `{${key}}`);
      else rval = rval.replace(new RegExp(`{${key}}`,"gi"), `{${value}}`);
    });
    return rval;
  }
  
  /**
   * Remove illegale html from the string
   * @param {String} e the html from where the illegale html tags has to be removed
   * @returns a string without the illegale html 
   */
  function stripOfXss(e) {
    if(!e)return
    let pattern = [];
    const forbiddenTags = ["script", "button"];
    pattern[0] = new RegExp(
      `<(?<tag>${forbiddenTags.join('|')}).*?>.*?<\/\\k<tag>>\n?`,
      "s",
    );
    // Remove all javascript eventhandlers that start with on
    pattern[1] = /on\w*\s*=\s*(\'|").*?(\'|")\s*/;
    // For image
    pattern[2] = /<img.*?>\n?/;
    let replacedText = e;
    pattern.forEach((reg) => {
      replacedText = replacedText.replace(reg, "");
    });
    return replacedText;
  }

/**
 * Give the tags the actual value of the backoffice_settings 
 * @param {String} e a string containing tags that has to be swapped with the data from the backoffice_settings
 * @param {Object} dataComp the data source from where the data of the tags will be extracted
 */
  function replaceData(e, dataComp = backoffice) {
    if(!e)return
    let replacedText = stripOfXss(e);
    Object.entries(companyInfo).forEach(([key, value]) => {
      replacedText = replacedText.replace(
        new RegExp(`{${key}}`, "ig"),
        dataComp[value],
      );
    });
    setEmailFootnoteCopy(replacedText);
  }
  if (loading)
    return (
      <div className="d-flex align-items-center justify-content-center">
        <LoadingIcon />
      </div>
    );
  return (
    <>
      <div className="d-flex gap-5 py-3">
        <div
          className="d-flex flex-column gap-1 row-gap-2"
          style={{ width: "fit-content" }}
        >
          {Object.keys(colors).map((color, i) => {
            return (
              <label className="colorname">
                <div>{colorNameMapping[color]}</div>
                <input
                  type="color"
                  value={colors[color]}
                  key={i}
                  onInput={(e) =>
                    setColors((k) => ({ ...k, [color]: e.target.value }))
                  }
                />
              </label>
            );
          })}
        </div>
        <div>
          <h4 className="fw-semibold text-capitalize mb-0">Tags</h4>
          <div className="text-muted mb-1" style={{ fontSize: ".75em" }}>
            Te gebruiken als {"{tag}"} waar <q>tag</q> een van de onderste
            opties is.
            <br />
            Het is niet hoofdletter gevoelig
          </div>
          <ul
            className="d-grid ps-3"
            style={{
              gridTemplateColumns: "repeat(5,1fr)",
              columnGap: "1.5em",
            }}
          >
            {Object.keys(companyInfo)
              .sort((a, b) => a.localeCompare(b))
              .map((e) => (
                <li key={e}>{`${e[0].toUpperCase()}${e.slice(1)}`}</li>
              ))}
          </ul>
        </div>
      </div>
      <h4 className="fw-semibold text-capitalize">Email footer text</h4>
      <TextEditor
        onBlur={(e) => {
          setBackoffice((k) => ({
            ...k,
            email_footnote: stripOfXss(e),
          }));
        }}
        onChange={(e) => {
          replaceData(stripOfXss(e));
        }}
        value={backoffice.email_footnote}
      />
      <h4 className="fw-semibold text-capitalize pt-1">Uitvoer</h4>
      <div
        className="border rounded-4 m-0 p-3"
        style={{ height: "150px", overflow: "auto" }}
        dangerouslySetInnerHTML={{ __html: emailFootnoteCopy }}
      ></div>
      <div className="d-flex justify-content-end pt-3">
        <ButtonBlue
          text={"Opslaan"}
          onClickFunction={() => submitEmailData()}
        />
      </div>
    </>
  );
};

export default EmailSettings;
